export default __webpack_public_path__ + "static/media/lincoln-fiuza.89222dc6.webp";